import React from 'react'
import { DateTime } from 'luxon';

const ProductSkipBin = ({ job }) => {


    const deliveryDate = DateTime.fromISO(job.dateOfFirstAction).toFormat("dd LLL yyyy");
    const removalDate = DateTime.fromISO(job.dateOfSecondAction).toFormat("dd LLL yyyy");

    return (
        <tr>
            <td className="text-left py-3">
                <div>
                    <div className="text-gray-700">
                        9M³ Skip Bin
                    </div>
                    <div className="text-sm font-light text-gray-500">
                        Delivery: {deliveryDate}
                    </div>
                    <div className="text-sm font-light text-gray-500">
                        Removal: {removalDate}
                    </div>
                </div>
            </td>
            <td className="px-3 text-gray-700 align-top pt-3">
                ${job.skipBinDetails.price}
            </td>
            <td className="px-3 text-gray-700 align-top pt-3">
                ${job.price}
            </td>
        </tr>
    )
}

export default ProductSkipBin;